import React from 'react';
import Callout from './callout';
export default function index({ bodyCopy }) {
  return (
    <Callout calloutTitle="Become a REMS-Certified Provider" buttonTitle="How Can You Become REMS&#x2060;-&#x2060;Certified" buttonLink="https://aveedrems.com/" isTargetBlank={true} bodyCopy={bodyCopy}>
      <p>Learn how you can become a prescriber through the AVEED<sup>&reg;</sup> REMS<sup>&dagger;</sup> Program.</p>
    </Callout>
  )
}
